/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { packagesList } from "../funcs/packagesList.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListPackagesResult } from "../models/components/listpackagesresult.js";
import {
  ListPackagesRequest,
  ListPackagesSecurity,
} from "../models/operations/listpackages.js";
import { unwrapAsync } from "../types/fp.js";
export type ListPackagesQueryData = ListPackagesResult;

export function prefetchListPackages(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListPackagesRequest | undefined,
  security?: ListPackagesSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildListPackagesQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildListPackagesQuery(
  client$: GramCore,
  request?: ListPackagesRequest | undefined,
  security?: ListPackagesSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<ListPackagesQueryData>;
} {
  return {
    queryKey: queryKeyListPackages({
      gramKey: request?.gramKey,
      gramSession: request?.gramSession,
      gramProject: request?.gramProject,
    }),
    queryFn: async function listPackagesQueryFn(
      ctx,
    ): Promise<ListPackagesQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(packagesList(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyListPackages(
  parameters: {
    gramKey?: string | undefined;
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "packages", "list", parameters];
}
